import React from "react";
import "./Help.css";
const Help = () => {
  return (
    <div>
      <h1>This is Help</h1>
    </div>
  );
};

export default Help;
